import { Http } from '../../utils/http'
import { Cookie } from '../../utils/cookie'
import { Api as Config } from '../../utils/config'
import { IGetGroupActivityListRes, IActivityDetailRes, IActivityRankRes, IGetUserInfoListRes } from './interface'

class Api {
    // 获取分组下的活动列表
    public static getGroupActivityList(id: number) {
        const url = this.host + '/votecenter/groups/activity_list' +
            `?group_id=${id}`
        return Http.get<{}, IGetGroupActivityListRes>(url)
    }

    // 获取活动详情
    public static getActivityDetail(id: number) {
        const url = this.host + `/votecenter/activity/${id}/info` +
            `?user_token=${this.token}` +
            `&union_id=${this.unionId}` +
            // TO DO
            `&client_type=${0}`
        return Http.get<{}, IActivityDetailRes>(url)
    }

    // 获取活动投票排名
    public static getActivityRank(id: number) {
        const url = this.host + `/votecenter/activity/${id}/rank` +
            `?user_token=${this.token}` +
            `&union_id=${this.unionId}`
        return Http.get<{}, IActivityRankRes>(url)
    }

    // 获取用户信息列表
    public static getUserInfoList(ids: string) {
        const url = this.host + '/usercenter/get_public_user_info_list' +
            `?user_ids=${ids}`
        return Http.get<{}, IGetUserInfoListRes>(url)
    }

    // 获取投票分享昵称
    public static getShareNick() {
        const url = this.host + '/votecenter/activities/share/nick' +
            `?user_token=${this.token}` +
            `&union_id=${this.unionId}`
        return Http.get(url)
    }

    private static host = Config().host
    private static token = Cookie.get()
    private static unionId = Cookie.get(Cookie.WECHATIDKEY)
}

export {
    Api
}


// WEBPACK FOOTER //
// ./src/components/activity_rank/api.tsx